var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1519_6939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.96 9.83334H20.6667V6.50001C20.6667 6.3232 20.5964 6.15363 20.4714 6.02861C20.3464 5.90358 20.1768 5.83334 20 5.83334H4C3.82319 5.83334 3.65362 5.7631 3.5286 5.63808C3.40357 5.51306 3.33333 5.34349 3.33333 5.16668C3.33333 4.98987 3.40357 4.8203 3.5286 4.69527C3.65362 4.57025 3.82319 4.50001 4 4.50001H19.7333C19.9101 4.50001 20.0797 4.42977 20.2047 4.30475C20.3298 4.17972 20.4 4.01015 20.4 3.83334C20.4 3.65653 20.3298 3.48696 20.2047 3.36194C20.0797 3.23691 19.9101 3.16668 19.7333 3.16668H4C3.7426 3.16137 3.48667 3.20683 3.24683 3.30045C3.007 3.39408 2.78797 3.53404 2.60224 3.71234C2.41651 3.89064 2.26773 4.10378 2.1644 4.3396C2.06106 4.57541 2.0052 4.82927 2 5.08668V19.0867C2.00087 19.4488 2.07318 19.8072 2.21277 20.1414C2.35236 20.4755 2.5565 20.7789 2.8135 21.034C3.0705 21.2891 3.3753 21.4911 3.71046 21.6282C4.04561 21.7654 4.40453 21.8351 4.76667 21.8333H20C20.1768 21.8333 20.3464 21.7631 20.4714 21.6381C20.5964 21.5131 20.6667 21.3435 20.6667 21.1667V17.8333H21.96C22.0441 17.8397 22.1287 17.8288 22.2085 17.8014C22.2883 17.7739 22.3616 17.7305 22.4241 17.6737C22.4865 17.6169 22.5366 17.5479 22.5715 17.4711C22.6063 17.3942 22.6251 17.311 22.6267 17.2267V10.56C22.6289 10.3768 22.5611 10.1996 22.4373 10.0646C22.3134 9.92961 22.1427 9.8469 21.96 9.83334ZM21.3333 16.5H15.6133C14.9301 16.4757 14.2845 16.1812 13.8182 15.6812C13.352 15.1812 13.1033 14.5166 13.1267 13.8333C13.1033 13.1501 13.352 12.4855 13.8182 11.9855C14.2845 11.4855 14.9301 11.191 15.6133 11.1667H21.3333V16.5Z",
    fill: "url(#paint0_linear_1519_6939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0269 14.78C16.5791 14.78 17.0269 14.3323 17.0269 13.78C17.0269 13.2277 16.5791 12.78 16.0269 12.78C15.4746 12.78 15.0269 13.2277 15.0269 13.78C15.0269 14.3323 15.4746 14.78 16.0269 14.78Z",
    fill: "url(#paint1_linear_1519_6939)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1519_6939",
    x1: 16.8251,
    y1: 4.09959,
    x2: 12.8878,
    y2: 21.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1519_6939",
    x1: 16.4643,
    y1: 12.88,
    x2: 16.0029,
    y2: 14.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E81825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C01519"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1519_6939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.e47fbc11249cb3a3c57840ec5af559d7.svg";
export { ForwardRef as ReactComponent };